
import React from 'react'

const EditIcon = ({width, height, opacity}) => {
    return (
        <svg
            width={width} 
            height={height} 
            viewBox="0 0 14 14" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M4.67424 13.3389L4.67421 13.3389C4.55431 13.4589 4.39614 13.5329 4.22725 13.5482L4.2272 13.5482L0.940644 13.847C0.72636 13.8666 0.514504 13.7899 0.362368 13.6377L0.362341 13.6377C0.210212 13.4856 0.133501 13.2736 0.152981 13.0594L0.00363281 13.0458L0.152982 13.0594L0.45176 9.77282C0.467116 9.60388 0.541208 9.44569 0.661127 9.32579L0.661133 9.32578L9.62459 0.362345L9.6246 0.362337C9.76053 0.226392 9.94497 0.15 10.1372 0.15C10.3295 0.15 10.5139 0.226377 10.6499 0.362365L13.6377 3.35016C13.9208 3.63328 13.9208 4.09234 13.6377 4.37547L4.67424 13.3389ZM8.57955 3.45796L8.47348 3.56403L8.57955 3.67009L10.3299 5.42046L10.436 5.52653L10.542 5.42047L11.9937 3.96887L12.0997 3.86281L11.9937 3.75674L10.2433 2.00637L10.1372 1.90031L10.0312 2.00637L8.57955 3.45796ZM9.30461 6.65791L9.41067 6.55184L9.30461 6.44578L7.55425 4.6954L7.44819 4.58933L7.34212 4.6954L1.91045 10.1271L1.87204 10.1655L1.86713 10.2196L1.69209 12.145L1.6758 12.3243L1.85506 12.308L3.78047 12.1329L3.83455 12.128L3.87295 12.0896L9.30461 6.65791Z" 
                fill="currentColor" 
                stroke="white" 
                strokeWidth="0.3"
            />
        </svg>
    )
}

export default EditIcon

EditIcon.defaultProps = {
    width: '14',
    height: '14',
}